<template>
  <div class="c-login">
    <div class="c-login__wrap">
      <svg
        class="c-login__logo o-svg-icon"
        viewBox="0 0 220 45"
        type="image/svg+xml"
      >
        <use
          xlink:href="spritemap.svg#sprite-logo-defaulthjeva"
          x="0"
          y="0"
        ></use>
      </svg>
      <div
        class="c-login__section o-grid o-grid--direction-column o-grid--gutter-small o-grid--align-items-center o-grid--justify-content-center"
      >
        <div class="o-grid__group">
          <div class="o-grid__item o-grid__item--grow-0">
            <h4 class="o-heading o-heading--size-4">
              {{ translationsLogin.login }}
            </h4>
          </div>
          <div class="o-grid__item o-grid__item--grow-0">
            <a href="#" :disabled="loggingIn" @click="handleAdLogin">
              <!-- Using image according to guidelines: https://docs.microsoft.com/en-us/azure/active-directory/develop/howto-add-branding-in-azure-ad-apps -->
              <img v-show="!loggingIn" src="../media/login.svg" />
              <img
                v-show="loggingIn"
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
              />
            </a>
          </div>
        </div>
      </div>
      <form
        class="c-login__section c-login__form"
        v-if="allowSimpleLogin"
        @submit.prevent="handleSubmit"
      >
        <div
          class="o-grid o-grid--direction-column o-grid--align-items-stretch"
        >
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <label class="o-label o-label--block" for="userName">{{
                translationsCustom.userName
              }}</label>
              <input
                id="userName"
                type="text"
                v-model="mutableUserName"
                name="userName"
                class="o-input o-input--modal c-login__input"
                placeholder="Brugernavn"
                :class="{
                  'o-input--is-invalid': submitted && !mutableUserName
                }"
              />
              <div
                v-show="submitted && !mutableUserName"
                class="o-feedback o-feedback--invalid"
              >
                <span>{{ translationsCustom.userNameIsRequired }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="o-grid o-grid--direction-column o-grid--align-items-stretch"
        >
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <label class="o-label o-label--block" for="password">{{
                translationsCustom.password
              }}</label>
              <input
                id="password"
                type="password"
                v-model="password"
                name="password"
                class="o-input o-input--modal c-login__input"
                placeholder="Adgangskode"
                :class="{ 'o-input--is-invalid': submitted && !password }"
              />
              <div
                v-show="submitted && !password"
                class="o-feedback o-feedback--invalid"
              >
                <span>{{ translationsCustom.passwordIsRequired }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="alertStatus" class="o-grid">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <div class="o-feedback o-feedback--invalid o-feedback--icon">
                <span>
                  {{
                    alertStatus === 401
                      ? translationsCustom.userNameOrPasswordIsIncorrect
                      : alertMessage
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="o-grid o-grid--direction-row o-grid--justify-content-space">
          <div class="o-grid__group">
            <div class="c-login__remember">
              <input
                id="remember"
                type="checkbox"
                v-model="mutableRemember"
                name="remember"
                class="o-input o-input--checkbox"
              />
              <label class="o-label" for="remember">{{
                translationsLogin.rememberMe
              }}</label>
            </div>
            <button class="o-button" type="submit" :disabled="loggingIn">
              <span v-show="!loggingIn">{{ translationsLogin.login }}</span
              ><img
                v-show="loggingIn"
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
              />
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "c-login",
  data() {
    return {
      mutableUserName: "",
      password: "",
      mutableRemember: false,
      submitted: false,
      allowSimpleLogin: false
    };
  },
  computed: {
    ...mapState("authentication", ["userNameToRemember"]),
    ...mapState("alert", {
      alertStatus: "status",
      alertMessage: "message"
    }),
    ...mapState("translations", {
      translationsCustom: "custom",
      translationsLogin: "login"
    }),
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    }
  },
  created() {
    this.mutableUserName = this.userNameToRemember;
    this.mutableRemember = this.userNameToRemember;
    this.logout();
  },
  methods: {
    ...mapActions("authentication", ["logout"]),
    handleSubmit() {
      this.submitted = true;
      const payload = {
        api: this.$api,
        username: this.mutableUserName,
        password: this.password,
        remember: this.mutableRemember
      };
      const { dispatch } = this.$store;
      if (payload.username && payload.password) {
        dispatch("authentication/login", payload);
      }
    },

    handleAdLogin() {
      const payload = {
        api: this.$api,
        ad: this.$ad
      };
      const { dispatch } = this.$store;
      dispatch("authentication/adlogin", payload);
    }
  }
};
</script>
<style lang="scss">
.c-login {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  &__wrap {
    background: $s-cp-neutral-white;
    width: 460px;
    max-width: 100%;
    padding: toRem(60px);
    margin: toRem(80px 0);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  }

  &__section {
    padding: 30px 0;
    border-top: 1px solid $s-cp-neutral-600;
  }

  &__logo {
    margin: toRem(0 auto 30px);
    width: 215px;
    display: block;
    fill: initial;
  }
  &__form {
    margin-bottom: toRem(35px);
  }
  &__forgot-heading {
    font-weight: 700;
    margin-bottom: toRem(7px);
  }
  &__forgot-text {
    color: $s-cp-neutral-300;
  }

  .o-grid + .o-grid {
    margin-top: toRem(25px);
  }

  &__input {
    width: 100%;
  }
}
</style>
